import './OrderRegist.css';
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

// 기존 upperRow, lowerRow 정의
const upperRow = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
const lowerRow = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

const OrderRegist = ({ username, userId, bcuCode, bcuName, gu, systemYN }) => {
 
  const [teethData, setTeethData] = useState([]);
  const [remark, setRemark] = useState("");
  const [patientName, setPatientName] = useState("");
  const [technician, setTechnician] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const [showTechnicianPopup, setShowTechnicianPopup] = useState(false);
  const [comCodes, setComCodes] = useState([]);
  const [deliveryMemo, setDeliveryMemo] = useState('');
  const [orderDate, setOrderDate] = useState('');         //format용
  const [orderDate2, setOrderDate2] = useState('');       //db용
  const [deliveryDate, setDeliveryDate] = useState('');   //format용
  const [deliveryDate2, setDeliveryDate2] = useState(''); //db용
  const [editError, setEditError] = useState('');
  const [secondTableData, setSecondTableData] = useState([]);
  const [deadlineTime, setDeadlineTime] = useState(''); //db용
  const [showButton, setShowButton] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [activeTime, setActiveTime] = useState(null);
  const [activeTimeStastus, setActiveTimeStastus] = useState(null);
  const [deliveryTimeStastus, setdeliveryTimeStastus] = useState('');
  const [nowTime, setNowTime] = useState(null);

  const isEmpty = (v) => v === null || v === undefined || v === '';

  const hasInvalidChars = (fileName) => /[\\/:*?"<>|#%]/.test(fileName);
  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const formatMB = (bytes) => (bytes / (1024 * 1024)).toFixed(1);

  const validateSingleFile = (file, { checkDuplicate = true } = {}) => {
    if (!file) return { ok: false, msg: '파일이 없습니다.' };
    if (/[\\/:*?"<>|#%]/.test(file.name)) {
      return { ok: false, msg: '파일명에 특수문자(%, #, ?, / 등)는 사용할 수 없습니다.' };
    }
    if (file.name.length > 100) {
      return { ok: false, msg: '파일명이 100글자를 초과할 수 없습니다.' };
    }
    if (file.size > MAX_FILE_SIZE) {
      return { ok: false, msg: `파일 크기가 20MB를 초과했습니다. (현재 ${formatMB(file.size)}MB)` };
    }
    if (checkDuplicate && isFileNameDuplicate(file.name)) {
      return { ok: false, msg: '이미 같은 파일명이 존재합니다.' };
    }
    return { ok: true };
  };

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  // 파일 input을 위한 ref
  const fileInputRef = useRef(null);

  const handleScroll = () => {
    // 문서의 전체 높이에서 뷰포트 높이를 빼고, 현재 스크롤 위치가 그 값보다 크면 버튼을 보이게    
    if (window.scrollY > 50) {  // 100px 이상 스크롤시 버튼 보이기 (필요에 따라 값 수정)
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // 컴포넌트가 언마운트 될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [])
  
  const handleSave = async () => {
    try {
      //deliveryTimeStastus를 강제로 재 할당해서 주문일, 배송예정일, 타임라인 3개를 모두 새로 받아온다.
      if (deliveryTimeStastus === 'Y')
        setdeliveryTimeStastus('N');     
      else
        setdeliveryTimeStastus('Y');        

      // 필수 입력값 검사
      if (!selectedTechnician || selectedTechnician.code === '기공사 선택') {
        // setEditError('기공사는 필수입력입니다.');
        alert('기공사는 필수입력입니다.');
        return;
      }

      if (!patientName) {
        alert('환자명은 필수입력입니다.');
        return;
      }
  
      if (teethData.length === 0) {
        // setEditError('치식 정보가 비어 있습니다. 최소한 하나의 치식을 입력해야 합니다.');
        alert('치식 정보가 비어 있습니다. 최소한 하나의 치식을 입력해야 합니다.');
        return;
      }
  
      for (let item of teethData) {
        if (
          !item.selectedComCode ||
          !item.selectedFixtureCode ||
          !item.selectedSizeCode ||
          !item.selectedTypeCode ||
          !item.selectedAnodizing ||
          isEmpty(item.selectedScrew)
        ) {
          // setEditError('모든 치식 항목에 대해 Implant, Fixture, Size, Type은 필수입력입니다.');
          alert('모든 치식 항목에 대해 Implant, Fixture, Size, Type, Anodizing, Screw는 필수입력입니다.');
          return;
        }
      }

      // fileNameStr을 teethData를 기반으로 생성
      const fileNameStr = teethData
        .map(item => item.files && item.files.file ? item.files.file.name + '_/' : '')
        .join('');

      for (let i = 0; i < teethData.length; i++) {
        const f = teethData[i]?.files?.file;
        if (!f) {
          alert('모든 치식 항목에 대해 첨부파일은 필수입니다.');
          return;
        }
        if (f.size > MAX_FILE_SIZE) {
          alert(`(${i + 1}번) 첨부 파일이 20MB를 초과했습니다. (현재 ${formatMB(f.size)}MB)`);
          return;
        }
      }
  
      if (fileNameStr === '') {
        // setEditError('모든 치식 항목에 대해 첨부파일은 필수입력입니다.');
        alert('모든 치식 항목에 대해 첨부파일은 필수입력입니다.');
        return;
      }
      
      const hours = deadlineTime;
      const minutes = '00';  
      const formattedTime = `${orderDate2} ${hours}:${minutes}`;     
       
      if (nowTime <= formattedTime){
        console.log('활성화일시 : ' + activeTime + '\n' + '저장일시 : ' + nowTime)}  
      else if(activeTime <= formattedTime){
        console.log('활성화일시 : ' + activeTime + '\n' + '저장일시 : ' + nowTime)  
        alert("배송예정일이 업데이트 되었습니다.\n배송예정일과 타임라인을 다시 확인해주세요.");        
      }   
      else{ 
        console.log('활성화일시 : ' + activeTime + '\n' + '저장일시 : ' + nowTime)  
      }
   
      // 사용자에게 등록 확인 메시지 띄우기
      const isConfirmed = window.confirm('등록하시겠습니까?');
      if (!isConfirmed) return;      
  
      // orderData 준비
      const orderData = {
        id: selectedTechnician.code,
        bcu_code: systemYN === 'Y' ? selectedCustomer.code : bcuCode,
        patientName: patientName,
        orderDate: orderDate2,
        deliveryDate: deliveryDate2,
        deliveryMemo: remark,
        teethData: teethData.map(item => ({
          ...item,
          selectedTooth: item.selectedTooth === null ? '' : item.selectedTooth,
        })),
        fileNameStr: fileNameStr,  // 파일명 문자열
      };
  
      // API 호출
      const response = await axios.post(`${serverUrl}/api/orderregist`, orderData);
  
      if (response.data) {
        const { CLIENTFILENAME, SERVERFILENAME } = response.data;
  
        if (CLIENTFILENAME && SERVERFILENAME) {  
          // SERVERFILENAME이 배열인 경우 처리
          if (Array.isArray(SERVERFILENAME)) {
            await uploadFilesToServer(teethData, SERVERFILENAME); // 서버 파일명 배열 전달
          } else {
            console.log('SERVERFILENAME은 배열이어야 합니다.');
          }
        } else {
          console.log('CLIENTFILENAME 또는 SERVERFILENAME이 없습니다.');
        }
  
        alert('주문이 성공적으로 저장되었습니다');        
        if (activeTimeStastus === 'Y')
          setActiveTimeStastus('N')
        else
          setActiveTimeStastus('Y')
        handleReset();
      }
    } catch (error) {
        console.error('주문 저장 오류:', error);

        let msg = "주문 저장 실패";

        if (error.response?.data?.error) {
          msg = error.response.data.error;
        } else if (error.message) {
          msg = error.message;
        }

        alert(msg);
      }

  };  
  
  // 여러 파일 업로드 함수
  const uploadFilesToServer = async (teethData, SERVERFILENAME) => {
    try {
      // 여러 개의 파일을 처리하기 위해 반복문
      for (let i = 0; i < teethData.length; i++) {
        const fileItem = teethData[i].files && teethData[i].files.file;  // 업로드할 파일
  
        if (fileItem) {
          const serverFileName = SERVERFILENAME[i];  // 서버에 저장할 파일명
  
          if (serverFileName) {
            const formData = new FormData();
            formData.append('file', fileItem);  // 'file' 필드로 파일을 첨부
            formData.append('SERVERFILENAME', JSON.stringify([serverFileName]));  // 해당 파일의 서버 파일명을 전송
            formData.append('fileIndex', i);  // 파일 인덱스를 추가
  
            // formData 내용 출력 (entries로 순차 출력)
            console.log(`Uploading file ${i}:`, serverFileName);
  
            const response = await axios.post(`${serverUrl}/api/orderregist/uploadfile`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
  
            // 서버 응답 처리
            if (response.data) {
              console.log(`파일 ${i} 업로드 성공:`, response.data);
            }
          }
        }
      }
    } catch (error) {
      console.error('파일 업로드 중 오류 발생:', error);
      alert('파일 업로드에 실패했습니다.');
    }
  };
  
  // 기공사 목록을 API로 가져오기
  const fetchOrderRegistTechnician = async () => {
    try {
      const response = await axios.get(`${serverUrl}/api/orderregist/technician/?bcucode=${systemYN === 'Y' ? selectedCustomer.code : bcuCode}`);
      
      // 서버 응답 데이터 매핑
      const techniciansData = response.data.map((tech) => ({
        id: tech.BCE_CODE,  // BCE_CODE를 id로
        name: tech.BCE_NAME,  // BCE_NAME을 name으로        
      }));
  
      // 기공사 목록을 상태에 저장
      setTechnician(techniciansData);
    } catch (err) {
      console.error("기공사 목록 가져오기 오류:", err);
    }
  };  
  
  useEffect(() => {
    const fetchComCodes = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/orderregist/comcodes?`);
        setComCodes(response.data);
      } catch (err) {
        console.error('COMCODE 데이터 조회 오류:', err);
      }
    };
    fetchComCodes();
  }, [selectedCustomer]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      fetchOrderRegistCustomer();  // Enter 키가 눌리면 조회 함수 실행
    }
  };
  
  //거래처 API
  const fetchOrderRegistCustomer = async () => {
    try {
      const response = await axios.get(`${serverUrl}/api/orderregist/customer?bcucode=${searchText}`);
      
      const customerData = response.data.map((cust) => ({
        id: cust.BCU_CODE,  
        name: cust.BCU_NAME,
      }));
  
      setCustomer(customerData);
      setSearchText('');
    } catch (err) {
      console.error("거래처 목록 가져오기 오류:", err);
    }
  };  

  const formatDate = (dateString) => {
    const date = new Date(dateString); // 날짜 문자열을 Date 객체로 변환
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 월은 0부터 시작하므로 +1
    const day = date.getUTCDate();  
    
    // 원하는 형식으로 날짜를 반환
    return `${year}년 ${month}월 ${day}일`;
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
  
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 월은 0부터 시작하므로 +1
    const day = date.getDate();        // getUTCDate → getDate (현지 기준일 경우)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
  
    // 두 자리 수로 맞추기 위한 보조 함수
    const pad = (n) => n.toString().padStart(2, '0');
  
    return `${year}-${pad(month)}-${pad(day)} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };
  

  useEffect(() => {
    const fetchDeliveryTimeline = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/orderregist/delivery?bcucode=${systemYN === 'Y' ? selectedCustomer.code : bcuCode}`);

        setSecondTableData(response.data.secondTableData);
      } catch (err) {
        console.error('delivery 데이터 조회 오류:', err);
      }
    };

    fetchDeliveryTimeline();
  }, [selectedCustomer, deliveryTimeStastus]);

  useEffect(() => {
    const fetchDelivery = async () => {
      try {
        // API 호출
        const response = await axios.get(`${serverUrl}/api/orderregist/delivery?bcucode=${systemYN === 'Y' ? selectedCustomer.code : bcuCode}`);

        const deliveryData = response.data?.firstTableData;
        if (!Array.isArray(deliveryData) || deliveryData.length === 0) {
          console.error("deliveryData가 존재하지 않거나 비어 있음");
          return;
        }
  
        // firstTableData에서 TODAY를 이용하여 날짜를 설정
        setOrderDate(formatDate(response.data.firstTableData[0].TODAY));
        setOrderDate2(response.data.firstTableData[0].TODAY);     
        
        const now = new Date(response.data.firstTableData[0].DEADLINE); // DEADLINE을 Date 객체로 변환
        const currentTimeFormatted = `${now.getUTCHours().toString().padStart(2, '0')}:${now.getUTCMinutes().toString().padStart(2, '0')}`;

        setDeadlineTime(currentTimeFormatted); // 상태에 업데이트
        setNowTime(formatDateTime(response.data.firstTableData[0].TODAYNOW))
  
        // 첫 번째 테이블 데이터가 배열일 경우, 첫 번째 항목에 접근
        if (Array.isArray(response.data.firstTableData)) {
          const formattedDate = formatDate(response.data.firstTableData[0].DELIVERYDATE);
          setDeliveryDate(formattedDate); // 포맷된 날짜를 상태에 저장
          setDeliveryDate2(response.data.firstTableData[0].DELIVERYDATE);
          setDeliveryMemo(response.data.firstTableData[0].REMARKS);
        } else {
          // 만약 첫 번째 테이블 데이터가 배열이 아니면 직접 객체에 접근
          const formattedDate = formatDate(response.data.firstTableData.DELIVERYDATE);
          setDeliveryDate(formattedDate); // 포맷된 날짜를 상태에 저장
          setDeliveryDate2(response.data.firstTableData[0].DELIVERYDATE);
          setDeliveryMemo(response.data.firstTableData.REMARKS);
        }
      } catch (err) {
        console.error('delivery 데이터 조회 오류:', err);
      }
    };
  
    setdeliveryTimeStastus('');
    fetchDelivery();
  }, [selectedCustomer, deliveryTimeStastus]);   
  
  //최초 화면 활성화시 activeTime 할당 -> 저장하고 나면 activeTimeStastus 변경되면서 다시 activeTime 재 할당(저장완료 또는 화면 활성화에만 activeTime 바뀜)
  useEffect(() => {
    const fetchActiveTime = async () => {
      try {
        // API 호출
        const response = await axios.get(`${serverUrl}/api/orderregist/delivery?bcucode=${systemYN === 'Y' ? selectedCustomer.code : bcuCode}`);

        setActiveTime(formatDateTime(response.data.firstTableData[0].TODAYNOW))
      } catch (err) {
        console.error('today 데이터 조회 오류:', err);
      }
    };
  
    fetchActiveTime();
  }, [activeTimeStastus]); 
  
  // 기공사 선택 팝업 열기
  const openTechnicianPopup = () => {
    fetchOrderRegistTechnician();  // 기공사 목록을 불러옴
    setShowTechnicianPopup(true);  // 팝업 열기
  };

  // 기공사 선택 함수
  const handleSelectTechnician = (technician) => {
    setSelectedTechnician({ name: technician.name, code: technician.id }); // name과 code 저장
    setShowTechnicianPopup(false); // 팝업 닫기
  };
  
  //거래처 팝업
  const openCustomerPopup = () => {
    fetchOrderRegistCustomer();  // 기공사 목록을 불러옴
    setShowCustomerPopup(true);  // 팝업 열기
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer({ name: customer.name, code: customer.id }); // name과 code 저장
    setTeethData([]);  // 치식 데이터 초기화
    setPatientName('');  // 환자명 초기화
    setRemark(''); 
    setSelectedTechnician(null);  // 기공사 초기화
    setShowCustomerPopup(false); // 팝업 닫기
  };

  const handleSelectComCode = async (id, comCodeId) => {
    try {
      // 🔥 먼저 API 호출
      const response = await axios.get(
        `${serverUrl}/api/orderregist/fixtures?comcode=${comCodeId}`
      );

      // 🔥 상태 업데이트 (id 기준)
      setTeethData(prev =>
        prev.map(item =>
          item.id === id
            ? {
                ...item,
                selectedComCode: comCodeId,
                selectedFixtureCode: null,
                selectedSizeCode: null,
                selectedTypeCode: null,
                selectedAnodizing: null,
                selectedScrew: null,
                fixtureCodes: response.data
              }
            : item
        )
      );
    } catch (err) {
      console.error('Fixture 데이터 조회 오류:', err);
    }
  };

  const handleSelectFixtureCode = async (id, fixtureCodeId) => {
    try {
      // 🔥 현재 선택된 item 찾기
      const currentItem = teethData.find(item => item.id === id);
      if (!currentItem) return;

      const { selectedComCode } = currentItem;

      // 🔥 API 호출
      const response = await axios.get(
        `${serverUrl}/api/orderregist/sizes?comcode=${selectedComCode}&fixture=${fixtureCodeId}`
      );

      // 🔥 상태 업데이트 (id 기준)
      setTeethData(prev =>
        prev.map(item =>
          item.id === id
            ? {
                ...item,
                selectedFixtureCode: fixtureCodeId,
                selectedSizeCode: null,
                selectedTypeCode: null,
                selectedAnodizing: null,
                selectedScrew: null,
                sizeCodes: response.data
              }
            : item
        )
      );
    } catch (err) {
      console.error('Size 데이터 조회 오류:', err);
    }
  };
  
  const handleSelectSizeCode = async (id, sizeCodeId) => {
    try {
      // 🔥 현재 선택된 item 찾기
      const currentItem = teethData.find(item => item.id === id);
      if (!currentItem) return;

      const { selectedComCode, selectedFixtureCode } = currentItem;

      // 🔥 API 호출
      const response = await axios.get(
        `${serverUrl}/api/orderregist/types?comcode=${selectedComCode}&fixture=${selectedFixtureCode}&size=${sizeCodeId}`
      );

      // 🔥 상태 업데이트 (id 기준)
      setTeethData(prev =>
        prev.map(item =>
          item.id === id
            ? {
                ...item,
                selectedSizeCode: sizeCodeId,
                selectedTypeCode: null,
                selectedAnodizing: null,
                selectedScrew: null,
                typeCodes: response.data
              }
            : item
        )
      );
    } catch (err) {
      console.error('Type 데이터 조회 오류:', err);
    }
  };

  const fetchScrew = async (id, anodizingYN) => {
    const item = teethData.find(t => t.id === id);

    if (!item) return;

    try {
      const res = await axios.get(
        `${serverUrl}/api/orderregist/screw?comcode=${item.selectedComCode}&fixture=${item.selectedFixtureCode}&size=${item.selectedSizeCode}&type=${item.selectedTypeCode}&anodizingyn=${anodizingYN}`
      );

      const screwCnt =
        res.data && res.data.length > 0
          ? res.data[0].SCREWCNT
          : "";

      setTeethData(prev =>
        prev.map(t =>
          t.id === id
            ? { ...t, selectedScrew: screwCnt }
            : t
        )
      );

    } catch (err) {
      console.error("screw 조회 오류", err);
    }
  };

  
  // typeCode 선택 시 처리
  const handleSelectTypeCode = async (id, typeCodeId) => {
    try {
      // 🔥 현재 항목 찾기
      const currentItem = teethData.find(item => item.id === id);
      if (!currentItem) return;

      // 🔥 API 호출
      const res = await axios.get(
        `${serverUrl}/api/orderregist/anodizing?comcode=${currentItem.selectedComCode}&fixture=${currentItem.selectedFixtureCode}&size=${currentItem.selectedSizeCode}&type=${typeCodeId}`
      );

      const anodizingCodes = [
        { ANODIZINGYN: "Y" },
        { ANODIZINGYN: "N" }
      ];

      let autoYN = null;

      if (res.data && res.data.length > 0) {
        autoYN = res.data[0].ANODIZINGYN;
      }

      // 🔥 상태 업데이트 (id 기준)
      setTeethData(prev =>
        prev.map(item =>
          item.id === id
            ? {
                ...item,
                selectedTypeCode: typeCodeId,
                selectedScrew: "",
                selectedAnodizing: autoYN,
                anodizingCodes
              }
            : item
        )
      );

      // 🔥 screw 조회도 id 기준으로 호출 (중요)
      if (autoYN !== null) {
        setTimeout(() => {
          fetchScrew(id, autoYN);   // ❗ index → id로 변경
        }, 0);
      }

    } catch (err) {
      console.error(err);
    }
  };


  // typeCode 선택 시 처리
  const handleSelectAnodizing = async (id, anodizingYN) => {
    setTeethData(prev =>
      prev.map(item =>
        item.id === id
          ? {
              ...item,
              selectedAnodizing: anodizingYN
            }
          : item
      )
    );

    setTimeout(() => {
      fetchScrew(id, anodizingYN);  // ❗ index → id
    }, 0);
  };

  const handleSelectScrew = (id, screwCnt) => {
    setTeethData(prev =>
      prev.map(item =>
        item.id === id
          ? {
              ...item,
              selectedScrew: screwCnt
            }
          : item
      )
    );
  };

  const createEmptyTeeth = (id) => ({
    id,
    teethNumbers: [...upperRow, ...lowerRow],
    selectedTooth: null,
    files: { file: null },
    selectedComCode: null,
    selectedFixtureCode: null,
    selectedSizeCode: null,
    selectedTypeCode: null,
    selectedAnodizing: null,
    selectedScrew: null
  });

  const createCopyTeeth = (id, base) => ({
    id,
    teethNumbers: [...upperRow, ...lowerRow],
    selectedTooth: null,
    files: { file: null },

    selectedComCode: base.selectedComCode ?? null,
    selectedFixtureCode: base.selectedFixtureCode ?? null,
    selectedSizeCode: base.selectedSizeCode ?? null,
    selectedTypeCode: base.selectedTypeCode ?? null,
    selectedAnodizing: base.selectedAnodizing ?? null,
    selectedScrew: base.selectedScrew ?? null,

    fixtureCodes: base.fixtureCodes ?? [],
    sizeCodes: base.sizeCodes ?? [],
    typeCodes: base.typeCodes ?? [],
    anodizingCodes: base.anodizingCodes ?? []
  });

  // 치식 데이터 추가 (빈 데이터 추가)
  const handleAddTeethData = () => {
    if (teethData.length >= 30) {
      alert("최대 30개까지 추가 가능합니다.");
      return;
    }

    const newId = `teeth-${teethData.length + 1}`;

    let newTeeth;

    if (teethData.length === 0) {
      // 🔥 1번 없음 → 기본 생성
      newTeeth = createEmptyTeeth(newId);
    } else {
      // 🔥 1번 있음 → 복사
      newTeeth = createCopyTeeth(newId, teethData[0]);
    }

    setTeethData(prev => [...prev, newTeeth]);
  };

  // 파일을 드래그 앤 드롭했을 때 처리
  const handleFileDrop = (event) => {
    event.preventDefault();

    const files = event.dataTransfer.files;
    const currentTeethCount = teethData.length;
    const remainingSlots = 30 - currentTeethCount;

    if (!files || files.length === 0) return;

    // 🔥 파일 검증
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      const v = validateSingleFile(file);
      if (!v.ok) {
        alert(v.msg);
        return;
      }
    }

    // 🔥 최대 개수 체크
    if (files.length + currentTeethCount > 30) {
      alert("최대 30개까지 추가 가능합니다.");
      return;
    }

    const fileCount = Math.min(files.length, remainingSlots);
    const base = teethData[0];

    // 🔥 1번 유효성 체크
    const isBaseValid =
      base &&
      base.selectedComCode &&
      base.selectedFixtureCode &&
      base.selectedSizeCode &&
      base.selectedTypeCode;

    const newTeethData = [];

    for (let i = 0; i < fileCount; i++) {
      const file = files[i];
      const id = `teeth-${currentTeethCount + i + 1}`;

      // 🔥 복사 or 기본 생성
      const newItem = isBaseValid
        ? createCopyTeeth(id, base)
        : createEmptyTeeth(id);

      // 🔥 파일만 주입
      newItem.files = { file };

      newTeethData.push(newItem);
    }

    // 🔥 상태 업데이트 (이게 핵심)
    setTeethData((prev) => [...prev, ...newTeethData]);
  };

  // 파일명 중복 여부 체크
  const isFileNameDuplicate = (fileName) => {
    return teethData.some(data => data.files.file && data.files.file.name === fileName);
  };

  useEffect(() => {
    // 최초 렌더링 시에만 실행되도록 빈 의존성 배열을 사용
    if (gu === "1" && selectedTechnician === null) {
      // selectedTechnician이 null일 때만 상태를 업데이트
      setSelectedTechnician({
        code: userId,   // technician code를 userId로 설정
        name: username, // technician name을 username으로 설정
      });
    }
  }, [gu, selectedTechnician, username, userId]); // 의존성 배열에는 gu

  useEffect(() => {
    const fileNameStr = teethData
      .map(item => {
        if (item.files && item.files.file && item.files.file.name) {
          return item.files.file.name + '_/';
        }
        return '';  // 파일이 없으면 빈 문자열 반환
      })
      .join('');
    
  }, [teethData]);  // teethData가 변경될 때마다 실행

  // 첨부파일 드래그 앤 드롭 시 파일명만 변경
  const handleFileDropInAttachment = (event, id) => {
    event.preventDefault();

    const file = event.dataTransfer.files[0];
    if (!file) return;

    // 🔥 핵심: setState 안에서 검사해야 함
    setTeethData(prevData => {

      // 🔥 최신 상태 기준 중복 체크
      const isDuplicate = prevData.some(
        item =>
          item.files?.file &&
          item.files.file.name === file.name &&
          item.files.file.size === file.size &&
          item.id !== id
      );

      if (isDuplicate) {
        alert("이미 같은 파일명이 존재합니다");
        return prevData; // ❗ 상태 변경 안함
      }

      // 🔥 정상 반영
      return prevData.map(item =>
        item.id === id
          ? { ...item, files: { ...item.files, file } }
          : item
      );
    });
  };

  

  // 파일 선택 시 처리 (여러 파일 선택 가능)
  const handleFileSelect = (event) => {
    const files = event.target.files;
    const currentTeethCount = teethData.length;
    const remainingSlots = 30 - currentTeethCount;

    // 파일 검증
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      const v = validateSingleFile(file);
      if (!v.ok) {
        alert(v.msg);
        event.target.value = "";
        return;
      }
    }

    // 최대 개수 체크
    if (files.length + currentTeethCount > 30) {
      alert("최대 30개까지 추가 가능합니다.");
      event.target.value = "";
      return;
    }

    const newTeethData = Array.from(files)
      .slice(0, remainingSlots)
      .map((file, index) => {
        const base = teethData[0];

        const id = `teeth-${currentTeethCount + index + 1}`;

        // 🔥 1번 유효성 체크 (핵심)
        const isBaseValid =
          base &&
          base.selectedComCode &&
          base.selectedFixtureCode &&
          base.selectedSizeCode &&
          base.selectedTypeCode;

        // 🔥 복사 or 기본 생성
        const newItem = isBaseValid
          ? createCopyTeeth(id, base)
          : createEmptyTeeth(id);

        // 파일만 따로 주입
        newItem.files = { file };

        return newItem;
      });

    setTeethData((prevData) => [...prevData, ...newTeethData]);

    event.target.value = ""; // input 초기화
  };
  
  // 치식 데이터 삭제
  const handleRemoveTeethData = (id) => {
    const isDelete = window.confirm('해당 치식을 삭제하시겠습니까?');
      if (!isDelete) return;

    setTeethData((prevData) => {
      return prevData.filter((item) => item.id !== id);
    });
  };

  // 치아 선택
  const handleSelectTooth = (id, number) => {
    setTeethData((prevData) =>
      prevData.map((data) =>
        data.id === id
          ? { ...data, selectedTooth: data.selectedTooth === number ? null : number }
          : data
      )
    );
  };

  // 환자명 변경
  const handlePatientNameChange = (event) => {
    setPatientName(event.target.value);
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  // 리셋 함수
  const handleReset = () => {
    const isReset = window.confirm('모두 리셋하시겠습니까?');
      if (!isReset) return;
      
    setTeethData([]);  // 치식 데이터 초기화
    setPatientName('');  // 환자명 초기화
    setRemark(''); 
    setSelectedTechnician(null);  // 기공사 초기화
    setEditError(''); // 오류 초기화
  };
  
  return (
    <div className="order-regist-container">
      <div className="form-container">
        <div className="header-row">
          <h2>주문 등록</h2>
          <div className="header-buttons">
            <button className="save-button" onClick={handleSave}>
              저장              
            </button>
            <button className="reset-button" onClick={handleReset}>
              리셋
            </button>
          </div>
        </div>
        <div className="info-section">
          <div className="left">                    
            <h3>주문 정보</h3>
            <div className="info-row">
              <span className="info-label">주문일</span>
              <span className="info-value">{orderDate}</span>
              {deadlineTime !== '' && (
                <span className="info-value">
                  (당일출고 마감시간 {deadlineTime})
                </span>
              )}
            </div>
            <div className="info-row">
              <span className="info-label">치과</span>
              <div className="info-wrap">
                <div className="info-value-with-button">
                  <span className="info-value">
                    {systemYN === 'Y'
                    ? (selectedCustomer ? selectedCustomer.name : "치과 선택")
                    : bcuName}
                  </span>                
                </div>
                {systemYN === 'Y' && (
                  <button onClick={openCustomerPopup} className="select-customer-button">
                    선택
                  </button>
                )}
              </div>
            </div>
            <div className="info-row">
              <span className="info-label">기공사</span>
              <div className="info-wrap">
                <div className="info-value-with-button">
                  <span className="info-value">
                    {selectedTechnician
                      ? selectedTechnician.name
                      : gu === "1"
                      ? username
                      : "기공사 선택"}
                  </span>                
                </div>
                <button onClick={openTechnicianPopup} className="select-technician-button">
                  선택
                </button>
              </div>
            </div>
            <div className="info-row">
              <span className="info-label">환자명</span>
              <input
                type="text"
                className="patient-name-input"
                value={patientName}
                onChange={handlePatientNameChange}
              />
            </div>          
            <div className="info-row">
              <span className="info-label">비고</span>       
              <input
                type="text"
                className="patient-name-input"
                value={remark}
                onChange={handleRemarkChange}
              />     
            </div>          
            <div className="info-row">
              <span className="info-label">배송예정일</span>
              <span className="info-value">{deliveryDate}</span>
              <span className="info-sub">{deliveryMemo}</span>
            </div>          
            {editError && <div className="error-message">{editError}</div>}     
          </div>          
          <div className="right">
            <h3>배송예정 타임라인</h3>
            <div className="timeline">
              {secondTableData.map((item, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <p><strong>{formatDate(item.DDATE)}</strong>  {item.REMARKS}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>                                      
        </div>                
      </div>

      {/* 치식 데이터 섹션 */}
      <div className="teeth-data-section">
        <div className="teeth-header">
          <h3>치식 데이터</h3>
          <button onClick={handleAddTeethData} className="add-teeth-button">
            추가
          </button>
        </div>

        {/* "Drag & Drop 또는 치식 추가" 영역 */}
        <div
          onClick={() => fileInputRef.current.click()}  // 클릭 시 파일 선택 창 열기
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleFileDrop}  // 여러 파일을 드래그하여 한꺼번에 추가
          className="drag-drop-area"
        >
          <span>Drag & Drop 또는 추가</span>
        </div>

        {/* 파일 선택 input (숨김 처리) */}
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }} // 숨김 처리
          onChange={handleFileSelect} // 선택된 파일을 해당 치식 항목에 추가
          multiple
        />

        {/* 치식 데이터 항목 렌더링 */}
        {teethData.map((data, index) => (
          <div key={data.id} className="teeth-data-item">
            {/* 치식 이미지 버튼 */}            
            <div className="teeth-row-upper">
              <div>                
                <div className="teeth-upper-buttons">
                  <label className="orederregist-title">치식({index+1})</label>
                  {upperRow.map((number) => (
                    <button
                      key={number}
                      className={`teeth-number-button ${data.selectedTooth === number ? "selected" : ""}`}
                      onClick={() => handleSelectTooth(data.id, number)}
                      style={{
                        backgroundImage: `url(/images/tooth-${number}.png)`,
                        backgroundPosition: data.selectedTooth === number ? "100% 0%" : "0% 0%",
                        backgroundSize: "200% 100%",
                      }}
                    />
                  ))}
                </div>
              </div>                                    
            </div>
            <div className="teeth-row-lower">
              <div className="teeth-lower-buttons">
                {lowerRow.map((number) => (
                  <button
                    key={number}
                    className={`teeth-number-button ${data.selectedTooth === number ? "selected" : ""}`}
                    onClick={() => handleSelectTooth(data.id, number)}
                    style={{
                      backgroundImage: `url(/images/tooth-${number}.png)`,
                      backgroundPosition: data.selectedTooth === number ? "100% 0%" : "0% 0%",
                      backgroundSize: "200% 100%",
                    }}
                  />
                ))}
              </div>      
            </div>            

            {/* ComCode 라디오 버튼 */}
            <div className="radio-group">
              <label className="orederregist-label">Implant</label>
              {comCodes.map((code) => (
                <label key={code.COMCODE}>
                  <input
                    type="radio"
                    name={`comCode-${index}`}  // 각 치식 항목에 대해 name을 다르게 설정
                    checked={data.selectedComCode === code.COMCODE}
                    onChange={() => handleSelectComCode(data.id, code.COMCODE)}  // 해당 치식 항목의 ComCode만 변경
                  />
                  {code.COMNAME}
                </label>
              ))}
            </div>

            {/* Fixture 라디오 버튼 */}
            <div className="radio-group">
              <label className="orederregist-label">Fixture </label>
              {data.fixtureCodes && data.fixtureCodes.length > 0 && data.fixtureCodes.map((code) => (
                <label key={code.FIXTURECODE}>
                  <input
                    type="radio"
                    name={`fixtureCode-${index}`}  // 각 치식 항목에 대해 name을 다르게 설정
                    checked={data.selectedFixtureCode === code.FIXTURECODE}
                    onChange={() => handleSelectFixtureCode(data.id, code.FIXTURECODE)}  // 해당 항목의 fixtureCode만 선택 처리
                  />
                  {code.FIXTURENAME}
                </label>
              ))}
            </div>

            {/* Size 라디오 버튼 */}
            <div className="radio-group">
              <label className="orederregist-label">Size </label>
              {data.sizeCodes && data.sizeCodes.length > 0 && data.sizeCodes.map((code) => (
                <label key={code.SIZECODE}>
                  <input
                    type="radio"
                    name={`sizeCode-${index}`}  // 각 치식 항목에 대해 name을 다르게 설정
                    checked={data.selectedSizeCode === code.SIZECODE}
                    onChange={() => handleSelectSizeCode(data.id, code.SIZECODE)}  // 해당 항목에 대한 sizeCode 선택 처리
                  />
                  {code.SIZENAME}
                </label>
              ))}
            </div>

            {/* Type 라디오 버튼 */}
            <div className="radio-group">
              <label className="orederregist-label">Type </label>
              {data.typeCodes && data.typeCodes.length > 0 && data.typeCodes.map((code) => (
                <label key={code.TYPECODE}>
                  <input
                    type="radio"
                    name={`typeCode-${index}`}  // 각 치식 항목에 대해 name을 다르게 설정
                    checked={data.selectedTypeCode === code.TYPECODE}
                    onChange={() => handleSelectTypeCode(data.id, code.TYPECODE)}  // 해당 항목에 대한 typeCode 선택 처리
                  />
                  {code.TYPENAME}
                </label>
              ))}
            </div>      
            {/* 아노다이징 */}
            <div className="radio-group">
              <label className="orederregist-label">Anodizing</label>

              {data.anodizingCodes && data.anodizingCodes.map((code) => (
                <label key={code.ANODIZINGYN}>
                  <input
                    type="radio"
                    name={`anodizing-${index}`}
                    checked={data.selectedAnodizing === code.ANODIZINGYN}
                    onChange={() => handleSelectAnodizing(data.id, code.ANODIZINGYN)}
                  />
                  {code.ANODIZINGYN}
                </label>
              ))}
            </div>
            {/* 스크류 */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <label className="orederregist-label">Screw</label>

              <input
                type="text"
                name={`screw-${index}`}
                value={data.selectedScrew ?? ""}
                onChange={(e) => handleSelectScrew(data.id, e.target.value)}
                style={{ width: 120 }}
              />
            </div>
            <div className="upload-container">
              {/* 첨부파일 영역 */}
              <label
                className="file-upload"
                htmlFor={`file-input-${data.id}`} // 이걸로 input과 연결
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleFileDropInAttachment(e, data.id)}
              >
                {data.files.file ? (
                  <span>{data.files.file.name}</span>
                ) : (
                  <span>첨부파일</span>
                )}
              </label>

              {/* 숨겨진 파일 선택 input */}
              <input
                type="file"
                id={`file-input-${data.id}`}
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files && e.target.files[0];
                  if (file) {
                    const fakeEvent = {
                      preventDefault: () => {},
                      dataTransfer: {
                        files: [file],
                      },
                    };
                    handleFileDropInAttachment(fakeEvent, data.id);
                  }
                  e.target.value = "";
                }}
              />

              <button
                onClick={() => handleRemoveTeethData(data.id)}
                className="remove-button"
              >
                삭제
              </button>
            </div>
     
          </div>
        ))}
      </div>

      {/* 하단 중앙에 새로운 저장 버튼 추가 */}
      <div className={`bottom-save-button-container ${showButton ? 'show' : ''}`}>
        <div className="header-buttons">
          <button className="save-button" onClick={handleSave}>
            저장
          </button>
          <button className="reset-bottom-button" onClick={handleReset}>
            리셋
          </button>
        </div>
      </div>

      {/* 기공사 선택 팝업 */}
      {showTechnicianPopup && (
        <div className="technician-popup">
          <div className="popup-content">
            <h3>기공사 선택</h3>
            <div className="table-popup-container">
              <table className="technician-popup-table">
                <thead>
                  <tr>
                    <th>기공사코드</th>
                    <th>기공사명</th>
                    <th>선택</th>
                  </tr>
                </thead>
                <tbody>
                  {technician.map((technician) => (
                    <tr key={technician.id}>
                      <td>{technician.id}</td>
                      <td>{technician.name}</td>
                      <td>
                        <button onClick={() => handleSelectTechnician(technician)} className="submit-button">
                          선택
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button onClick={() => setShowTechnicianPopup(false)} className="close-popup-button">
              닫기
            </button>
          </div>
        </div>
      )}

      {showCustomerPopup && (
        <div className="technician-popup">
          <div className="popup-content">
            <h3>치과 선택</h3>       
            <label htmlFor="searchText"></label>
            <input className = "search-textbox"
              type="text"
              name="searchText"
              id="searchText"
              placeholder="검색어 입력"
              onChange={handleSearchChange} 
              onKeyDown={handleSearchKeyPress} 
            />
            <div className="table-popup-container">
              <table className="technician-popup-table">
                <thead>
                  <tr>
                    <th>치과코드</th>
                    <th>치과명</th>
                    <th>선택</th>
                  </tr>
                </thead>
                <tbody>
                  {customer.map((customer) => (
                    <tr key={customer.id}>
                      <td>{customer.id}</td>
                      <td>{customer.name}</td>
                      <td>
                        <button onClick={() => handleSelectCustomer(customer)} className="submit-button">
                          선택
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button onClick={() => fetchOrderRegistCustomer()} className="search-popup-button">
              조회
            </button>
            <button onClick={() => setShowCustomerPopup(false)} className="close-popup-button">
              닫기
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderRegist;
